import { BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";
import Panel, {
  PanelHeader,
  PanelBody,
  PanelFooter,
  PanelHeading,
  PanelProps,
} from ".";

export type SimplePanelProps = PanelProps & {
  bodyProps?: BoxProps;
  footer?: ReactNode;
  header?: ReactNode;
  heading?: ReactNode;
  isAutoHeight?: boolean;
  isFlushBody?: boolean;
};

export default function SimplePanel({
  bodyProps,
  children,
  footer,
  header,
  heading,
  isAutoHeight,
  isFlushBody,
  ...rest
}: SimplePanelProps) {
  return (
    <Panel
      {...(isAutoHeight ? { display: "flex", flexFlow: "column" } : {})}
      {...rest}
    >
      {(header || heading) && (
        <PanelHeader>
          {heading && <PanelHeading>{heading}</PanelHeading>}
          {header}
        </PanelHeader>
      )}

      <PanelBody
        {...(isAutoHeight
          ? { flex: "1 1 100%", display: "flex", flexFlow: "column" }
          : {})}
        {...(isFlushBody ? { padding: 0 } : {})}
        {...bodyProps}
      >
        {children}
      </PanelBody>

      {footer && <PanelFooter>{footer}</PanelFooter>}
    </Panel>
  );
}
